import {useState} from 'react'
import {useParams} from 'react-router-dom'
import {Space} from 'antd'

import styles from './BorrowerProjectAboutDetails.module.scss'
import {IDocument, useGetDocuments} from 'modules/documents'

import {
  Box,
  Text,
  Button,
  Loader,
  File,
  SkyscraperIcon,
} from 'common/components'
import {maybePluralize, formatMoney, formatDate} from 'common/helpers'
import {isProjectRequest, useGetProject} from '..'

interface DetailsProps {
  project: any
  documents: IDocument[]
}

export default function BorrowerProjectAboutDetails() {
  const params = useParams()
  const {data: project} = useGetProject(params.uuid)
  const {data: documents} = useGetDocuments(params.uuid)

  return (
    <div className={styles.root}>
      <Space size={6}>
        <SkyscraperIcon width={26} height="100%" />
        <Text size="2xl" weight="medium">
          {maybePluralize(project.units, 'unit')}
        </Text>
      </Space>
      <Text maxInterval mt={16} mb={16}>
        {project.description}
      </Text>
      <Details project={project} documents={documents} />
    </div>
  )
}

const Details = ({project, documents}: DetailsProps) => {
  const isRequest = isProjectRequest(project)
  const [isOpen, setOpen] = useState(isRequest)

  const handleClick = isRequest ? undefined : () => setOpen((state) => !state)

  const request = project.loanRequests[0]

  return (
    <>
      {isOpen && (
        <Box fadeIn>
          <div className={styles.block}>
            <Text weight="medium" mb={4}>
              Requested
            </Text>
            <Text size="3xl" weight="medium" mb={4}>
              {formatMoney(request.loanValueRequested, {
                cents: true,
              })}
            </Text>
            <Text color="grey" size="xs" weight="medium">
              Est. {formatDate(request.openDate)}
              <Box as="span" ml={6} mr={6}>
                ⇢
              </Box>
              Est. {formatDate(request.maturityDate)}
            </Text>
          </div>
          <div className={styles.block}>
            <h4 className={styles.title}>Your background</h4>
            <Text maxInterval>{project.borrowerBackgroundDescription}</Text>
          </div>
          {documents ? (
            documents.length ? (
              <div className={styles.block}>
                <h4 className={styles.title}>Documents</h4>
                <ul className={styles.documents}>
                  {documents.map((document) => (
                    <li key={document.uuid}>
                      <File
                        uuid={document.uuid}
                        name={document.name}
                        size={document.size}
                        url={document.url}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            ) : null
          ) : (
            <Loader />
          )}
        </Box>
      )}
      {!isRequest && (
        <Button variant="secondary" onClick={handleClick}>
          {isOpen ? 'hide' : 'show'} request details
        </Button>
      )}
    </>
  )
}
